import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  StateStoring,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarTipoAlvaraConstrucaoDs } from "../../DataSources";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroParamIptuGridState";

export default class TiposAlvaraConstrucaoBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.tiposDs = criarTipoAlvaraConstrucaoDs();
    this.moedas = [
      { id: 0, descricao: "Real" },
      { id: 1, descricao: "Unidade Fiscal" }
    ];
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("/tipos_alvara_construcao/editar/" + e.data.id);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar
          titulo="TIPOS DE ALVARÁ CONSTRUÇÃO"
          novoCb={this.novoRegistro.bind(this)}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.tiposDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            focusedRowEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            onEditingStart={this.onAtualizandoRow}
          >
            <StateStoring
              enabled={true}
              type={"localStorage"}
              storageKey={localStorageKey}
            />
            <Editing allowDeleting={true} allowUpdating={true} mode />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"80px"}
              alignment={"center"}
              visible={false}
            />
            <Column
              dataField={"sequencial"}
              caption={"#"}
              width={"80px"}
              alignment={"center"}
              visible={true}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"titulo"} caption={"Título"} />

            <Column dataField={"leiaute"} caption={"Leiaute"} />

            <Column dataField={"tipoMoeda"} caption={"Moeda"}>
              <Lookup dataSource={this.moedas} displayExpr={"descricao"} valueExpr={"id"} />
            </Column>

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("/tipos_alvara_construcao/novo");
  }
}
